'use strict';

var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var IndexSection = require('components/IndexSection/IndexSection');

require('./IndexPower.less');

module.exports = IndexSection.extend({

    //is next section on show animation lies under or moves from outside
    NEXT_SECTION_MOVE: false,

    el: '.IndexPower',

    events: _.extend({
        'mouseenter': 'onMouseEnter'
    }, IndexSection.prototype.baseEvents),


    initialize: function (options) {

        _.bindAll(this, 'onResourcesReady', 'onResize');

        if (app.settings.isDesktop && Modernizr.webgl && !Modernizr.ieany) {
            this.effectLevel = 'webgl';

            this.resources = {
                'map': app.staticPath + 'img/IndexPower/world.jpg',
            };
        } else {
            this.effectLevel = 'photo';

            if (app.settings.isPhone) {
                this.resources = {
                    'photo': app.staticPath + 'img/IndexPower/globe_phone.jpg',
                };
            } else {
                this.resources = {
                    'photo': app.staticPath + 'img/IndexPower/globe_tablet.jpg',
                };
            }
        }

        this.$el.attr('data-effect', this.effectLevel);

        this.on('resources-ready', this.onResourcesReady);

        IndexSection.prototype.initialize.call(this, options);
    },


    onResourcesReady: function() {
        this.createGlobe();
    },


    show: function (params) {

        if (this.effectLevel == 'webgl') {
            var self = this;
            this.globe.startAnimation();

            clearTimeout(this.showGloboTimeout);
            this.showGloboTimeout = setTimeout(function () {
                this.animateBars(1, 2000);
            }.bind(this), 2500);
        }

        IndexSection.prototype.show.call(this, params);

        if (this.effectLevel == 'webgl') {
            this.globe.proceedResize();

            //to always face Europe at show
            this.globe.setMouseCorrection();
        }

        this.paralaxHandler && this.paralaxHandler.resume();

        this.onResize();

        $(window).on('resize', this.onResize);
    },


    hide: function (params) {
        IndexSection.prototype.hide.call(this, params);

        if (this.effectLevel == 'webgl') {
            this.animateBars(0, 1000);
        }

        this.paralaxHandler && this.paralaxHandler.pause();
    },


    onHideEnd: function(params) {
        $(window).off('resize', this.onResize);
    },


    animateBars: function(time, duration) {
        var tween = new TWEEN.Tween(this.globe).to({time: time}, duration).easing(TWEEN.Easing.Cubic.EaseOut).start();
        var self = this;

        cancelAnimationFrame(self.barsFrame);
        animate();

        var startTime = + new Date();

        //animate the bars running outside the globus
        function animate(time) {
            var currentTime = + new Date();

            if (currentTime - startTime > duration) {
                tween.stop();
                return;
            }

            self.barsFrame = requestAnimationFrame(animate);

            TWEEN.update(time);
        }
    },


    createGlobe: function () {
        var self = this;

        if (this.effectLevel == 'photo') {
            this.$('.IndexPower-wrapper').css('background-image', 'url(' + this.resources['photo'] + ')');

            this.paralaxHandler = this.initParallax();

            return;
        }

        this.prepareData();

        var colors = [
            0x399cb4,
            0x3ed0bd,
            0x3badb8,
            0x3042a5,
            0x3148a6,
            0x314ea7,
            0x3464aa,
            0x3cbdba,
            0x3254a8,
            0x3ed4be,
            0x303ea4,
            0x3dcabc,
            0x346eac,
            0x3576ad,
            0x335ca9,
            0x3cc4bb,
            0x3bb5b9,
            0x3789b1,
            0x39a5b6,
            0x3893b3,
            0x3680b0,
        ];

        //create globe
        this.globe = DAT.Globe(this.$('.IndexPower-wrapper')[0], {
            img: this.resources['map'],
            colorFn: function (label) {
                return new THREE.Color(colors[label]);
            }
        });

        //2 types of data to animate globa bars
        var data = window.app.data.globe;
        for (var i = 0; i < data.length; i++) {
            this.globe.addData(data[i][1], {format: 'legend', name: data[i][0], animated: true});
        }


        this.globe.createPoints();

        //for smooth first play
        this.$el.show();

        setTimeout(prerender, 30);
        setTimeout(prerender, 60);

        setTimeout(function() {
            this.$el.hide();
        }.bind(this), 90);

        function prerender() {
            self.globe.proceedResize();
            self.globe.startAnimation();
            self.globe.stopAnimation();
        }
    },

    prepareData: function () {
/*        var data = window.app.data.globe;
        var points = data[1][1].slice(0);
        var newPoints = [];

        for (var i = 0; i < points.length; i += 4) {
            var len = points[i + 2];
            var used = true;
            if (len == 0) used = Math.random() * 100 < 10;
            if (used) {
                newPoints.push(points[i]);
                newPoints.push(points[i + 1]);
                newPoints.push(points[i + 2]);
                newPoints.push(points[i + 3]);
            }
        }

        var data = window.app.data.globe;

        data[1][1] = newPoints;
        console.log(JSON.stringify(data));*/

        var data = window.app.data.globe;
        data[0][1] = data[1][1].slice(0);

        for (var i = 2; i < data[0][1].length; i += 4) {
            data[0][1][i] = 0
        }
    },


    onResize: function () {
        this.photoWidth = this.$('.IndexPower-wrapper').width();
        this.photoHeight = this.$('.IndexPower-wrapper').height();
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    },


    initParallax: function () {

        var animationFrameId, stopTimeout,
            dxTarget = 0,
            prevX,
            dx = 0,
            dyTarget = 0,
            dy = 0,
            inertion = 0,
            tracking = false,
            self = this;


        return {
            resume: function () {
                if (app.settings.isDesktop) {
                    $('body').on('mouseenter', startTracking);
                    $('body').on('mouseleave', stopTracking);
                    $('body').on('mousemove', mousePosChanged);
                } else {
                    window.addEventListener('deviceorientation', orientationChanged, false);
                    startTracking();
                }
            },

            pause: function () {
                stopTracking();

                if (app.settings.isDesktop) {
                    $('body').off('mouseenter', startTracking);
                    $('body').off('mouseleave', stopTracking);
                    $('body').off('mousemove', mousePosChanged);
                } else {
                    window.removeEventListener('deviceorientation', orientationChanged, false);
                }
            }
        };


        function startTracking() {
            tracking = true;

            clearTimeout(stopTimeout);
            window.cancelAnimationFrame(animationFrameId);

            inertion = 0;
            applyParalax();

            function applyParalax() {
                dx += (dxTarget - dx) * inertion;
                dy += (dyTarget - dy) * inertion;

                self.dx = dx;
                self.dy = dy;

                inertion = Math.min(inertion + 0.01, 0.1);

                var xPhotoShift = -dx * (self.photoWidth - self.windowWidth - 4) / 2;
                var yPhotoShift = -dy * (self.photoHeight - self.windowHeight - 4) / 2;

                self.$('.IndexPower-wrapper').css({
                    'transform': 'translate3d(' + -Math.round(xPhotoShift * 10) / 10 + 'px, ' + -Math.round(yPhotoShift * 10) / 10 + 'px, 0)'
                });

                animationFrameId = window.requestAnimationFrame(applyParalax);
            }
        }


        function stopTracking() {
            inertion = 0;
            tracking = false;
            window.cancelAnimationFrame(animationFrameId);
        }


        function orientationChanged(e) {
            switch (window.orientation) {
                case 0:
                    dyTarget = -(.02 * e.beta - .25 * Math.PI);
                    dxTarget = .03 * -e.gamma;
                    break;
                case 90:
                    dyTarget = -(.02 * -e.gamma - .25 * Math.PI);
                    dxTarget = .04 * -e.beta;
                    break;
                case -90:
                    dyTarget = -(.02 * e.gamma - .25 * Math.PI);
                    dxTarget = .04 * e.beta;
            }

            dyTarget > .8 ? dyTarget = .8 : dyTarget < -.8 && (dyTarget = -.8);
            dxTarget > .8 ? dxTarget = .8 : dxTarget < -.8 && (dxTarget = -.8);
            dy = dyTarget;
            dx = dxTarget;
        }


        function mousePosChanged(e) {
            dxTarget = e.pageX / (self.windowWidth / 2) - 1;
            dyTarget = e.pageY / (self.windowHeight / 2) - 1;

            prevX = e.pageX;

            if (!tracking) {
                startTracking();
            }
        }
    },

});


/**
 * dat.globe Javascript WebGL Globe Toolkit
 * https://github.com/dataarts/webgl-globe
 *
 * Copyright 2011 Data Arts Team, Google Creative Lab
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Modifications copyright (C) 2018 JTB
 */

var DAT = DAT || {};

DAT.Globe = function (container, opts) {
    opts = opts || {};

    var colorFn = opts.colorFn || function (x) {
        var c = new THREE.Color();
        c.setHSL(( 0.6 - ( x * 0.5 ) ), 1.0, 0.5);
        return c;
    };
    var img = opts.img;

    var Shaders = {
        'earth': {
            uniforms: {
                'texture': {type: 't', value: null}
            },
            vertexShader: [
                'varying vec3 vNormal;',
                'varying vec2 vUv;',
                'void main() {',
                'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
                'vNormal = normalize( normalMatrix * normal );',
                'vUv = uv;',
                '}'
            ].join('\n'),
            fragmentShader: [
                'uniform sampler2D texture;',
                'varying vec3 vNormal;',
                'varying vec2 vUv;',
                'void main() {',
                'vec3 diffuse = texture2D( texture, vUv ).xyz;',
                'float intensity = 1.05 - dot( vNormal, vec3( 0.0, 0.0, 1.0 ) );',
                'vec3 atmosphere = vec3( 1.0, 1.0, 1.0 ) * pow( intensity, 3.0 );',
                'gl_FragColor = vec4( diffuse + atmosphere, 1.0 );',
                '}'
            ].join('\n')
        },
        'atmosphere': {
            uniforms: {},
            vertexShader: [
                'varying vec3 vNormal;',
                'void main() {',
                'vNormal = normalize( normalMatrix * normal );',
                'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
                '}'
            ].join('\n'),
            fragmentShader: [
                'varying vec3 vNormal;',
                'void main() {',
                'float intensity = pow( 0.8 - dot( vNormal, vec3( 0, 0, 1.0 ) ), 12.0 );',
                'gl_FragColor = vec4( 1.0, 1.0, 1.0, 1.0 ) * intensity;',
                '}'
            ].join('\n')
        }
    };

    var camera, scene, renderer, w, h;
    var mesh, atmosphere, point;

    var overRenderer;

    var curZoomSpeed = 0;
    var zoomSpeed = 50;

    var mouse = {x: 0, y: 0}, mouseOnDown = {x: 0, y: 0};
    var rotation = {x: 0, y: 0};

    //calculate position in index.js for nice start animation
    var target = app.globoPos;
    var targetOnDown = {x: 0, y: 0};

    var distance = 1000, distanceTarget = 1000;
    var padding = 40;
    var PI_HALF = Math.PI / 2;
    var PI_180 = Math.PI / 180;

    var animationFrame;

    var mouseCorrection = {
        dx: 0,
        dy: 0
    }

    function init() {

        container.style.color = '#fff';
        container.style.font = '13px/20px Arial, sans-serif';

        var shader, uniforms, material;
        w = container.offsetWidth || window.innerWidth;
        h = container.offsetHeight || window.innerHeight;

        camera = new THREE.PerspectiveCamera(30, w / h, 1, 10000);
        camera.position.z = distance;

        scene = new THREE.Scene();
        //scene.background = new THREE.Color(0xff0000);

        var geometry = new THREE.SphereGeometry(200, 40, 30);

        shader = Shaders['earth'];
        uniforms = THREE.UniformsUtils.clone(shader.uniforms);

        uniforms['texture'].value = THREE.ImageUtils.loadTexture(img);

        material = new THREE.ShaderMaterial({

            uniforms: uniforms,
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader

        });

        mesh = new THREE.Mesh(geometry, material);
        mesh.rotation.y = Math.PI;
        scene.add(mesh);

        shader = Shaders['atmosphere'];
        uniforms = THREE.UniformsUtils.clone(shader.uniforms);

        material = new THREE.ShaderMaterial({

            uniforms: uniforms,
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: THREE.BackSide,
            blending: THREE.AdditiveBlending,
            transparent: true

        });

        mesh = new THREE.Mesh(geometry, material);
        mesh.scale.set(1.1, 1.1, 1.1);
        scene.add(mesh);

        geometry = new THREE.BoxGeometry(0.75, 0.75, 1);
        geometry.applyMatrix(new THREE.Matrix4().makeTranslation(0, 0, -0.5));

        point = new THREE.Mesh(geometry);

        renderer = new THREE.WebGLRenderer({antialias: true});
        renderer.setSize(w, h);
        renderer.setClearColor( 0x141720, 0);

        renderer.domElement.style.position = 'absolute';

        container.appendChild(renderer.domElement);

        //JTB - disable
        //container.addEventListener('mousedown', onMouseDown, false);

        //JTB - added
        // calculation of globo position move to index.js for nice start animation on show
        // document.body.addEventListener('mousemove', onMouseMove, false);

        //JTB - disable
        //container.addEventListener('mousewheel', onMouseWheel, false);

        //JTB - disable
        //document.addEventListener('keydown', onDocumentKeyDown, false);

        window.addEventListener('resize', onWindowResize, false);

        //JTB - disable
        // container.addEventListener('mouseover', function() {
        //   overRenderer = true;
        // }, false);

        //JTB - disable
        // container.addEventListener('mouseout', function() {
        //   overRenderer = false;
        // }, false);
    }

    function addData(data, opts) {
        var lat, lng, size, color, i, step, colorFnWrapper;
        opts.animated = opts.animated || false;
        this.is_animated = opts.animated;
        opts.format = opts.format || 'magnitude'; // other option is 'legend'
        if (opts.format === 'magnitude') {
            step = 3;
            colorFnWrapper = function (data, i) {
                return colorFn(data[i + 2]);
            }
        } else if (opts.format === 'legend') {
            step = 4;
            colorFnWrapper = function (data, i) {
                return colorFn(data[i + 3]);
            }
        } else {
            throw('error: format not supported: ' + opts.format);
        }

        if (opts.animated) {
            if (this._baseGeometry === undefined) {
                this._baseGeometry = new THREE.Geometry();
                for (i = 0; i < data.length; i += step) {
                    lat = data[i];
                    lng = data[i + 1];
//        size = data[i + 2];
                    color = colorFnWrapper(data, i);
                    size = 0;
                    addPoint(lat, lng, size, color, this._baseGeometry);
                }
            }
            if (this._morphTargetId === undefined) {
                this._morphTargetId = 0;
            } else {
                this._morphTargetId += 1;
            }
            opts.name = opts.name || 'morphTarget' + this._morphTargetId;
        }
        var subgeo = new THREE.Geometry();
        for (i = 0; i < data.length; i += step) {
            lat = data[i];
            lng = data[i + 1];
            color = colorFnWrapper(data, i);
            size = data[i + 2];
            size = size * 200;
            addPoint(lat, lng, size, color, subgeo);
        }
        if (opts.animated) {
            this._baseGeometry.morphTargets.push({'name': opts.name, vertices: subgeo.vertices});
        } else {
            this._baseGeometry = subgeo;
        }

    };

    function createPoints() {
        if (this._baseGeometry !== undefined) {
            if (this.is_animated === false) {
                this.points = new THREE.Mesh(this._baseGeometry, new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    vertexColors: THREE.FaceColors,
                    morphTargets: false
                }));
            } else {
                if (this._baseGeometry.morphTargets.length < 8) {
                    var padding = 8 - this._baseGeometry.morphTargets.length;
                    for (var i = 0; i <= padding; i++) {
                        this._baseGeometry.morphTargets.push({
                            'name': 'morphPadding' + i,
                            vertices: this._baseGeometry.vertices
                        });
                    }
                }
                this.points = new THREE.Mesh(this._baseGeometry, new THREE.MeshBasicMaterial({
                    color: 0xffffff,
                    vertexColors: THREE.FaceColors,
                    morphTargets: true
                }));
            }
            scene.add(this.points);
        }
    }

    function addPoint(lat, lng, size, color, subgeo) {

        var phi = (90 - lat) * PI_180;
        var theta = (180 - lng) * PI_180;
        var sinPhi = Math.sin(phi);

        point.position.x = 200 * sinPhi * Math.cos(theta);
        point.position.y = 200 * Math.cos(phi);
        point.position.z = 200 * sinPhi * Math.sin(theta);

        point.lookAt(mesh.position);

        point.scale.z = Math.max(size, 0.1); // avoid non-invertible matrix
        if (size == 0) {
            point.scale.x = 1.3;
            point.scale.y = 1.3;
        } else {
            point.scale.x = 1.1;
            point.scale.y = 1.1;
        }
        point.updateMatrix();

        for (var i = 0; i < point.geometry.faces.length; i++) {

            point.geometry.faces[i].color = color;

        }

        //it's useless here
        // if (point.matrixAutoUpdate) {
        //     point.updateMatrix();
        // }
        subgeo.merge(point.geometry, point.matrix);
    }

    function onMouseDown(event) {
        event.preventDefault();

        container.addEventListener('mousemove', onMouseMove, false);
        container.addEventListener('mouseup', onMouseUp, false);
        container.addEventListener('mouseout', onMouseOut, false);

        mouseOnDown.x = -event.clientX;
        mouseOnDown.y = event.clientY;

        targetOnDown.x = target.x;
        targetOnDown.y = target.y;

        container.style.cursor = 'move';
    }

    function onMouseMove(event) {
        mouse.x = -event.clientX;
        mouse.y = event.clientY - window.innerHeight / 2;

        var zoomDamp = distance / 1000;

        target.x = targetOnDown.x + (mouse.x - mouseOnDown.x) * 0.003 * zoomDamp;
        target.y = targetOnDown.y + (mouse.y - mouseOnDown.y) * 0.003 * zoomDamp;

        target.y = target.y > PI_HALF ? PI_HALF : target.y;
        target.y = target.y < -PI_HALF ? -PI_HALF : target.y;
    }

    function onMouseUp(event) {
        container.removeEventListener('mousemove', onMouseMove, false);
        container.removeEventListener('mouseup', onMouseUp, false);
        container.removeEventListener('mouseout', onMouseOut, false);
        container.style.cursor = 'auto';
    }

    function onMouseOut(event) {
        container.removeEventListener('mousemove', onMouseMove, false);
        container.removeEventListener('mouseup', onMouseUp, false);
        container.removeEventListener('mouseout', onMouseOut, false);
    }

    function onMouseWheel(event) {
        event.preventDefault();
        if (overRenderer) {
            zoom(event.wheelDeltaY * 0.3);
        }
        return false;
    }

    function onDocumentKeyDown(event) {
        switch (event.keyCode) {
            case 38:
                zoom(100);
                event.preventDefault();
                break;
            case 40:
                zoom(-100);
                event.preventDefault();
                break;
        }
    }

    function onWindowResize(event) {
        camera.aspect = container.offsetWidth / container.offsetHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(container.offsetWidth, container.offsetHeight);
    }


    function startAnimation() {
        cancelAnimationFrame(animationFrame);

        distance = 10000;
        animateFrame();

        function animateFrame() {
            animationFrame = requestAnimationFrame(animateFrame);
            render();
        }
    }

    function stopAnimation() {
        cancelAnimationFrame(animationFrame);
    }

    function render() {

        rotation.x += (target.x - rotation.x ) * 0.018;
        rotation.y += (target.y - rotation.y) * 0.018;
        distance += (distanceTarget - distance) * 0.07;

        var x = rotation.x - mouseCorrection.dx;
        var y = rotation.y - mouseCorrection.dy;

        y = y > PI_HALF ? PI_HALF : y;
        y = y < -PI_HALF ? -PI_HALF : y;

        camera.position.x = distance * Math.sin(x) * Math.cos(y);
        camera.position.y = distance * Math.sin(y);
        camera.position.z = distance * Math.cos(x) * Math.cos(y);

        camera.lookAt(mesh.position);

        renderer.render(scene, camera);
    }


    function setMouseCorrection() {
        var europePos = {
            x: -1.296,
            y: 0.339
        }

        mouseCorrection.dx = target.x - europePos.x;
        mouseCorrection.dy = target.y - europePos.y;

        console.log(mouseCorrection, target);

        rotation.x = target.x;
        rotation.y = target.y;
    }

    init();
    this.startAnimation = startAnimation;
    this.stopAnimation = stopAnimation;


    this.__defineGetter__('time', function () {
        return this._time || 0;
    });

    this.__defineSetter__('time', function (t) {
        var validMorphs = [];
        var morphDict = this.points.morphTargetDictionary;
        for (var k in morphDict) {
            if (k.indexOf('morphPadding') < 0) {
                validMorphs.push(morphDict[k]);
            }
        }
        validMorphs.sort();
        var l = validMorphs.length - 1;
        var scaledt = t * l + 1;
        var index = Math.floor(scaledt);
        for (var i = 0; i < validMorphs.length; i++) {
            this.points.morphTargetInfluences[validMorphs[i]] = 0;
        }
        var lastIndex = index - 1;
        var leftover = scaledt - index;
        if (lastIndex >= 0) {
            this.points.morphTargetInfluences[lastIndex] = 1 - leftover;
        }
        this.points.morphTargetInfluences[index] = leftover;
        this._time = t;
    });

    this.addData = addData;
    this.createPoints = createPoints;
    this.renderer = renderer;
    this.scene = scene;
    this.proceedResize = onWindowResize;
    this.setMouseCorrection = setMouseCorrection;

    return this;

};




/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/components/IndexPower/IndexPower.js
 ** module id = 16
 ** module chunks = 0
 **/